import { useChallengesData } from './../../hooks/useChallengesData';

export default function ChallengesData() {
  return useChallengesData()
}
